module.exports = __webpack_public_path__ + "static/7-5ed5f1ea84b05b3fe5d29de809e6dc9c.jpeg";